import { render, staticRenderFns } from "./WpMenuMain.vue?vue&type=template&id=21a1815d&scoped=true&"
import script from "./WpMenuMain.vue?vue&type=script&lang=js&"
export * from "./WpMenuMain.vue?vue&type=script&lang=js&"
import style0 from "./WpMenuMain.vue?vue&type=style&index=0&id=21a1815d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1815d",
  null
  
)

export default component.exports